import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { SelectInput, TextInput } from '../../../Helpers/Inputs';
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import RulerIcon from '../../../../../src/icons/icRuler.svg';
import FormHeader from './FormHeader';
import BasicDetails from '../../BasicDetails';
import GetYearList from '../../../Helpers/Lists/YearList';
import { number as yupnumber } from "../../../Helpers/Validators/customValidators";
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import BackNextButton from '../../../Common/BackNextButton';

export default function AdditionalClientInfo(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: AdditionalClientInfo.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'lifeReplacementYears' });
    setValue('lifeReplacementYears', props.formState.lifeReplacementYears);

    register({ name: 'collegeExpense' });
    setValue('collegeExpense', props.formState.collegeExpense);
  }, [register]);

  return (
    <div>
      <Container fluid className="border-class">
        <Form onSubmit={handleSubmit(props.onNext)}>
        {props.StartOverButton}
        <Row className="justify-content-center pt-3 client-coverage">
          <Col lg={4} className='analysis-info'>
          <FormHeader title="Additional Client Information"   Icon={RulerIcon} />
           <Form.Group>
                <SelectInput
                  name="lifeReplacementYears"
                  id="lifeReplacementYears"
                  value={props.formState.lifeReplacementYears}
                  onChange={e => handleValueChange('lifeReplacementYears', e.target.value)}
                  label="Policy Length"
                  selectOptions={GetYearList(0,25)}
                  errors={errors.lifeReplacementYears}
                  inputRef={register}
                />
                <span className="select-apply">Client’s number of Years To Replace Income</span>
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="collegeExpense"
                  id="collegeExpense"
                  label="Education Expenses"
                  value={props.formState.collegeExpense}
                  errors={errors && errors.collegeExpense}
                  inputRef={register}
                  onChange={e => handleValueChange('collegeExpense', e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
                <span className="select-apply">Total cost of education for the children of client</span>
              </Form.Group>
            </Col>
          </Row>
          <BackNextButton onBack={props.onBack} />
        </Form>
      </Container>
      <BasicDetails
        fullFormState={props.fullFormState}
      />
    </div>
  );
}

AdditionalClientInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

AdditionalClientInfo.ValidationSchema = object().shape({
  lifeReplacementYears: string().required('This field is required.'),
  collegeExpense:   yupnumber()
  .transform(emptyStringToUndefined)
  .required("This field is required.")
  .max(1000000, "Amount must be less than or equal to $1,000,000."),
});

AdditionalClientInfo.DefaultFormState = (prefill = false) => {
  return {
    lifeReplacementYears: prefill ? '10' : '10',
    collegeExpense: prefill ? '100000' : ''
  };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/AdditionalClientInfo.js